import { connect } from 'react-redux';
import LoginScreen from '../components/LoginScreen/LoginScreen';
import actions from '../../actions';
import { withRouter } from 'react-router';

const mapStateToProps = (state) => ({
  loginStatus: state.session.loginStatus,
  response: state.session.response,
  recovery: state.session.emailStatus,

  // ! FRONT QUICK FIX !
  tooManyLoginAttempts: state.session.tooManyLoginAttempts,

  // Subscribe to i18n state to re-render on language change
  locale: state.i18n.locale,
});

const mapDispatchToProps = (dispatch) => ({
  login: (email, password) => {
    dispatch(actions.session.login(email, password));
  },
  baproLogin: (email, password) => {
    dispatch(actions.session.baproLogin(email, password));
  },
  loginFormReset: () => {
    dispatch(actions.session.loginFormReset());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(LoginScreen));
